import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common/constants';

const states: Ng1StateDeclaration[] = [
    {
        name: 'applicationUsers',
        url: '/applicationUsers',
        template: '<wt-application-users class="flex-directive"></wt-application-users>',
        abstract: true,
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([
                Roles.administrator, Roles.master, Roles.engineer, Roles.reader
            ])
        },
        data: {
            visible: false,
            sortingOrder: 20,
            icon: 'fa-user-circle-o',
            displayName: 'Application users',
            editRoles: [Roles.administrator],
            editButtonVisibility: () => false,
        }
    },
    {
        name: 'applicationUsers.roles',
        url: '/roles',
        template: '<wt-application-roles-state class="flex-directive"></wt-application-roles-state>',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([
                Roles.administrator, Roles.master, Roles.engineer
            ])
        },
        data: {
            visible: true,
            sortingOrder: 20,
            icon: 'fa-user-circle-o',
            displayName: 'Application roles',
            editRoles: [Roles.administrator],
            editButtonVisibility: () => false,
        }
    },
    {
        name: 'applicationUsers.approvalStrategies',
        url: '/approvalStrategies',
        template: '<wt-approval-strategies selected-strategy="vm.selectedItem" class="flex-directive" contextual-form-controller="vm.formController" form-controller="vm.levelsFormController"></wt-approval-strategies>',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([
                Roles.administrator, Roles.master, Roles.engineer
            ])
        },
        data: {
            visible: false,
            sortingOrder: 21,
            icon: ' fa-thumbs-o-up',
            displayName: 'Approval strategies',
            editRoles: [Roles.administrator],
            editButtonVisibility: () => true,
        }
    },
    {
        name: 'applicationUsers.dashboardRights',
        url: '/dashboardRights',
        template: '<wt-dashboard-rights class="flex-directive"></wt-dashboard-rights>',
        resolve: {
            roles: Resolve.rolesResolve([
                Roles.engineer, Roles.master, Roles.administrator
            ])
        },
        data: {
            visible: false,
            sortingOrder: 22,
            icon: 'fa-th-large',
            displayName: 'Dashboard rights',
            editRoles: [Roles.engineer, Roles.master, Roles.administrator],
            editButtonVisibility: () => false,
        }
    },
    {
        name: 'applicationUsers.userGroups',
        url: '/userGroups',
        template: require('./userGroups/userGroups.template.html'),
        resolve: {
            roles: Resolve.rolesResolve([
                Roles.engineer, Roles.master, Roles.administrator
            ])
        },
        data: {
            visible: false,
            sortingOrder: 23,
            icon: 'fa-users',
            displayName: 'User groups',
            editRoles: [Roles.engineer, Roles.master, Roles.administrator],
            editButtonVisibility: () => true,
        }
    }
];

export default states;